import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { useApp } from "../context/AppContext";

const HeroCarousel = ({ banners = [] }) => {
  const { lang, t } = useApp();
  const [i, setI] = useState(0);
  useEffect(() => {
    if (banners.length <= 1) return;
    const id = setInterval(() => setI((v) => (v + 1) % banners.length), 6500);
    return () => clearInterval(id);
  }, [banners.length]);

  if (!banners.length) return null;
  const b = banners[i];
  const title = b[`title_${lang}`] || b.title_en;
  const subtitle = b[`subtitle_${lang}`] || b.subtitle_en;
  const cta = b[`cta_label_${lang}`] || b.cta_label_en || t("shop_now");

  return (
    <section className="relative" data-testid="hero-carousel">
      <div className="relative h-[70vh] min-h-[480px] max-h-[760px] overflow-hidden">
        {banners.map((banner, idx) => (
          <div
            key={banner.id || idx}
            className={`absolute inset-0 transition-opacity duration-1000 ${idx === i ? "opacity-100" : "opacity-0"}`}
          >
            <img src={banner.image_url} alt={banner.title_en} className="w-full h-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-r from-foreground/45 via-foreground/15 to-transparent" />
          </div>
        ))}

        <div className="absolute inset-0 flex items-center">
          <div className="max-w-7xl mx-auto w-full px-6 sm:px-12">
            <div className="max-w-xl text-ivory">
              <div className="text-[11px] tracking-[0.35em] uppercase text-holy-gold mb-4 font-semibold">
                ✦ Festive Collection 2026 ✦
              </div>
              <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl leading-[1.05] mb-5 drop-shadow">
                {title}
              </h1>
              <p className="text-ivory/90 text-base sm:text-lg leading-relaxed mb-8 max-w-md">
                {subtitle}
              </p>
              <Link
                to={b.cta_link || "/shop"}
                className="inline-flex items-center gap-2 bg-holy-red hover:bg-holy-red-dark text-ivory rounded-full px-8 py-3.5 font-sans font-medium tracking-wide transition-all duration-300 hover:-translate-y-0.5 hover:shadow-xl"
                data-testid="hero-cta"
              >
                {cta} →
              </Link>
            </div>
          </div>
        </div>

        {banners.length > 1 && (
          <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex gap-2">
            {banners.map((_, idx) => (
              <button
                key={idx}
                onClick={() => setI(idx)}
                className={`h-1.5 rounded-full transition-all ${idx === i ? "bg-ivory w-10" : "bg-ivory/40 w-2"}`}
                aria-label={`Banner ${idx + 1}`}
              />
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default HeroCarousel;
